import React from "react";

export function ProductCardSkeleton() {
    return (
        <div className="bg-white border border-brand-line rounded-2xl overflow-hidden">
            <div className="skeleton aspect-square" />
            <div className="p-5 space-y-3">
                <div className="skeleton h-3 w-16" />
                <div className="skeleton h-5 w-3/4" />
                <div className="skeleton h-6 w-20" />
                <div className="skeleton h-11 w-full" />
            </div>
        </div>
    );
}

export function ProductGridSkeleton({ count = 4 }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {Array.from({ length: count }).map((_, i) => (
                <ProductCardSkeleton key={i} />
            ))}
        </div>
    );
}

export function LineSkeleton({ w = "w-full", h = "h-4" }) {
    return <div className={`skeleton ${h} ${w}`} />;
}
